import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllGames, searchGames } from '../services/gamesService';
import GameCard from '../components/GameCard';
import SearchBar from '../components/SearchBar';
import './HomePage.css';

const HomePage = () => {
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const allGames = getAllGames();
    setGames(allGames);
    setFilteredGames(allGames);
    
    const urlParams = new URLSearchParams(window.location.search);
    const subscription = urlParams.get('subscription');
    const token = urlParams.get('token');
    
    if (subscription === 'success' && token) {
      import('../services/subscriptionService').then(({ setAccessAllowed }) => {
        setAccessAllowed(true);
        alert('Subscription successful! You now have access to all premium games.');
        window.history.replaceState({}, document.title, window.location.pathname);
      });
    }
  }, []);

  useEffect(() => {
    if (searchTerm) {
      setFilteredGames(searchGames(searchTerm));
    } else {
      setFilteredGames(games);
    }
  }, [searchTerm, games]);

  const handleGameClick = (gameId) => {
    navigate(`/content/get/${gameId}`);
  };

  return (
    <div className="home-page">
      <header className="home-header">
        <h1>🎮 Action Game</h1>
        <SearchBar onSearchChange={setSearchTerm} />
      </header>

      <div className="games-section">
        <div className="games-header">
          <h2>{searchTerm ? `"${searchTerm}"` : 'Featured Games'}</h2>
          <span className="games-count">{filteredGames.length} games</span>
        </div>
        
        <div className="games-grid">
          {filteredGames.length > 0 ? (
            filteredGames.map(game => (
              <GameCard 
                key={game.id}
                game={game}
                onGameClick={handleGameClick}
              />
            ))
          ) : (
            <div className="no-games">
              <p>No games found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
